// enums

export const MENU_TYPES = {
    PICKUP: 'PICKUP',
    DELIVERY: 'DELIVERY',
    PICKUP_AND_DELIVERY: 'PICKUP_AND_DELIVERY',
    ON_PREMISE: 'ON_PREMISE'
}